import React from 'react';

export const Underline = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.856 8.872V17H9.92C9.70667 17 9.568 16.896 9.504 16.688L9.392 15.872C9.216 16.0587 9.032 16.2293 8.84 16.384C8.648 16.5387 8.44267 16.672 8.224 16.784C8.00533 16.8907 7.77333 16.9733 7.528 17.032C7.28267 17.096 7.01867 17.128 6.736 17.128C6.288 17.128 5.89333 17.0533 5.552 16.904C5.216 16.7547 4.93333 16.5467 4.704 16.28C4.47467 16.008 4.30133 15.6827 4.184 15.304C4.06667 14.9253 4.008 14.5067 4.008 14.048V8.872H5.576V14.048C5.576 14.6293 5.70933 15.0827 5.976 15.408C6.24267 15.728 6.65067 15.888 7.2 15.888C7.6 15.888 7.97333 15.7947 8.32 15.608C8.66667 15.416 8.992 15.1547 9.296 14.824V8.872H10.856ZM14.4975 10C14.6735 9.81333 14.8575 9.64267 15.0495 9.488C15.2415 9.33333 15.4442 9.20267 15.6575 9.096C15.8762 8.984 16.1082 8.89867 16.3535 8.84C16.6042 8.776 16.8708 8.744 17.1535 8.744C17.6015 8.744 17.9935 8.81867 18.3295 8.968C18.6708 9.11733 18.9562 9.328 19.1855 9.6C19.4148 9.86667 19.5882 10.1893 19.7055 10.568C19.8228 10.9467 19.8815 11.3653 19.8815 11.824V17H18.3135V11.824C18.3135 11.2427 18.1802 10.792 17.9135 10.472C17.6468 10.1467 17.2388 9.984 16.6895 9.984C16.2895 9.984 15.9135 10.08 15.5615 10.272C15.2148 10.4587 14.8922 10.7147 14.5935 11.04V17H13.0335V8.872H13.9695C14.1882 8.872 14.3242 8.976 14.3775 9.184L14.4975 10Z"
      fill="black"
    />
    <line stroke="black" x1="4" x2="20" y1="19.5" y2="19.5" />
  </svg>
);
